import { render } from "./order.vue?vue&type=template&id=05a43806&scoped=true&ts=true"
import script from "./order.vue?vue&type=script&lang=ts"
export * from "./order.vue?vue&type=script&lang=ts"

import "./order.vue?vue&type=style&index=0&id=05a43806&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/nonbid_zlysz_com_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a43806"]])

export default __exports__